var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('i',{staticClass:"fa-solid fa-cog fa-10x fa-spin cog"}),_c('HelloWorld',{attrs:{"code":"404","msg":"This page is not available"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }